import React, { useState } from "react";
import { IconButton, Menu, MenuItem, CircularProgress } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { makeStyles } from "@material-ui/core";

type Props = {
  options: any;
  setIsEditButtonDarkMode?: any;
  style?: any;
  customOptionWidth?: any;
  loading?: boolean;
  isOnMenu?: boolean;
  setIsOnMenu?: any;
};

const useStyles = makeStyles(() => ({
  list: {
    display: "flex",
    flexDirection: "column",
  },
  root: {
    display: "block",
    paddingLeft: "20px",
  },
  loading: {
    marginLeft: "5px",
    marginRight: "5px",
  },
}));
export const FloatingMenu = ({
  options,
  setIsEditButtonDarkMode,
  style,
  loading,
  customOptionWidth,
  isOnMenu,
  setIsOnMenu = () => {},
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const classes = useStyles();

  const handleClickOpen = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (e: any) => {
    e.stopPropagation();
    setAnchorEl(null);
    setIsEditButtonDarkMode(false);
  };

  return (
    <div
      style={style}
      onMouseEnter={() => {
        setIsOnMenu(true);
      }}
      onMouseLeave={() => {
        setIsOnMenu(false);
      }}
    >
      <IconButton
        aria-label="more"
        disabled={!options.length}
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClickOpen}
      >
        {loading ? (
          <CircularProgress size={20} className={classes.loading} />
        ) : (
          <MoreVertIcon />
        )}
      </IconButton>

      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        classes={classes}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: 48 * 4.5,
            width: customOptionWidth || "20ch",
          },
        }}
      >
        {options.map((option: any) => (
          <MenuItem
            classes={classes}
            disabled={option.disabled}
            key={option.text}
            onClick={(e) => {
              option.handler(e);
              handleClose(e);
            }}
          >
            {option.text}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
